import React, { useState } from 'react';
import { Row, Col, Button, Form } from 'react-bootstrap';
import Select from 'react-select';
import { FaPlus } from 'react-icons/fa';
import { selectStylesSm } from '~/Styles/reactSelectStyles';

const FormDepartamento = ({ departamentosOpts, contasAtuais, somaAtual, onAdicionar, disabled }) => {
  const [deptoSelecionado, setDeptoSelecionado] = useState(null);
  const [percentual, setPercentual] = useState('');
  const [erro, setErro] = useState('');

  const idsJaAdicionados = new Set((contasAtuais || []).map((c) => c.departamento));

  const opcoesDisponiveis = (departamentosOpts || []).filter(
    (d) => !idsJaAdicionados.has(d.value)
  );

  const handleAdicionar = () => {
    setErro('');
    if (!deptoSelecionado) {
      setErro('Selecione um departamento.');
      return;
    }
    const pct = parseFloat(String(percentual).replace(',', '.'));
    if (isNaN(pct) || pct <= 0) {
      setErro('Percentual deve ser maior que zero.');
      return;
    }
    if (pct > 100) {
      setErro('Percentual não pode ultrapassar 100.');
      return;
    }
    if (somaAtual + pct > 100.0001) {
      setErro(`Adicionar ${pct}% ultrapassaria 100% (atual: ${somaAtual.toFixed(2)}%).`);
      return;
    }
    onAdicionar({
      departamento: deptoSelecionado.value,
      descricao_depto: deptoSelecionado.label,
      percentual: pct,
    });
    setDeptoSelecionado(null);
    setPercentual('');
  };

  const percentualDefault = Math.max(0, 100 - somaAtual);

  const handleDeptoChange = (opt) => {
    setDeptoSelecionado(opt);
    if (opt && percentual === '') {
      setPercentual(percentualDefault > 0 ? String(percentualDefault.toFixed(2)) : '');
    }
  };

  return (
    <div className="border rounded p-2 bg-light">
      <Row className="align-items-end no-gutters">
        <Col xs={12} md={6} className="pr-md-2 mb-2 mb-md-0">
          <Form.Label className="small mb-1">Departamento</Form.Label>
          <Select
            styles={selectStylesSm}
            options={opcoesDisponiveis}
            value={deptoSelecionado}
            onChange={handleDeptoChange}
            placeholder="Selecionar departamento..."
            isDisabled={disabled}
            noOptionsMessage={() => 'Nenhum departamento disponível'}
            menuPortalTarget={document.body}
            menuPosition="fixed"
          />
        </Col>
        <Col xs={8} md={4} className="pr-2 mb-2 mb-md-0">
          <Form.Label className="small mb-1">Percentual (%)</Form.Label>
          <Form.Control
            size="sm"
            type="number"
            step="0.01"
            min="0.01"
            max="100"
            value={percentual}
            onChange={(e) => setPercentual(e.target.value)}
            onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); handleAdicionar(); } }}
            disabled={disabled}
            placeholder={percentualDefault > 0 ? `${percentualDefault.toFixed(2)}` : '0.00'}
          />
        </Col>
        <Col xs={4} md={2} className="mb-2 mb-md-0">
          <Form.Label className="small mb-1 d-none d-md-block">&nbsp;</Form.Label>
          <Button size="sm" variant="success" onClick={handleAdicionar} disabled={disabled} className="w-100">
            <FaPlus className="mr-1" /> Adicionar
          </Button>
        </Col>
      </Row>
      {erro && <small className="text-danger mt-1 d-block">{erro}</small>}
    </div>
  );
};

export default FormDepartamento;
